angular.module('impactx.beco').controller('BecoOrderVChargeListCtrl', BecoOrderVChargeListCtrl);

function BecoOrderVChargeListCtrl() {
    this.meta = {
        rowTemplate: 'modules/beco/templates/beco.row.html',
        isSelectAble: false,
        endpoint: '/beco/ordervcharge',
        ctrl: this,
        id: "becoordervchargelist",
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    };
}